/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_DeletedInputs */

const en_admin_roles_deleted = /** @type {(inputs: Admin_Roles_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role deleted`)
};

/**
* | output |
* | --- |
* | "Role deleted" |
*
* @param {Admin_Roles_DeletedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_deleted = /** @type {((inputs?: Admin_Roles_DeletedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_DeletedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_deleted(inputs)
});
export { admin_roles_deleted as "admin.roles.deleted" }